// Confirmed form conversions only. No field values, email or customer ID are read.
(() => {
  const key = 'albero_ads_form_pending';
  const allowed = () => window.consensoMarketing === true;
  const newId = () => 'albero_' + crypto.randomUUID();
  const delivered = new Set();

  function publish(name, id, attempt = 0) {
    if (!allowed() || delivered.has(id)) return;
    const analytics = window.Shopify?.analytics;
    if (!analytics?.publish) {
      if (attempt < 40) setTimeout(() => publish(name, id, attempt + 1), 250);
      return;
    }
    delivered.add(id);
    // Only this opaque deduplication ID leaves the page.
    Promise.resolve(analytics.publish('albero:' + name, { eventId: id })).catch(() => {
      delivered.delete(id);
    });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const type = form.querySelector('input[name="form_type"]')?.value;
    if (!['contact', 'customer'].includes(type)) return;
    try {
      sessionStorage.removeItem(key);
      if (!allowed() || !form.id) return;
      sessionStorage.setItem(key, JSON.stringify({
        formId: form.id, type, id: newId(), time: Date.now()
      }));
    } catch (_) { /* Storage unavailable: skip rather than duplicate a conversion. */ }
  }, true);

  let themeConsentResolved = false;
  function confirmedThemeForms() {
    if (themeConsentResolved || typeof window.consensoMarketing !== 'boolean') return;
    themeConsentResolved = true;
    if (!allowed()) {
      try { sessionStorage.removeItem(key); } catch (_) {}
      return;
    }
    try {
      const pending = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!pending) return;
      if (Date.now() - pending.time > 10 * 60 * 1000 || Date.now() < pending.time) {
        sessionStorage.removeItem(key);
        return;
      }
      for (const marker of document.querySelectorAll('[data-albero-ads-success]')) {
        if (marker.closest('form')?.id !== pending.formId) continue;
        const name = marker.getAttribute('data-albero-ads-success');
        if (name !== 'lead_created' || !['contact', 'customer'].includes(pending.type)) continue;
        // Consume before publishing: reloads must not count the same success twice.
        sessionStorage.removeItem(key);
        publish(name, pending.id);
        break;
      }
    } catch (_) {}
  }

  // Omnisend's documented primary conversion event, excluding intermediate steps.
  window.addEventListener('omnisendForms', (event) => {
    const detail = event.detail;
    if (!allowed() || (detail?.type || detail?.eventName) !== 'submit' || !detail.form?.id) return;
    const id = 'omnisend_' + detail.form.id;
    if (delivered.has(id)) return;
    delivered.add(id);
    publish('lead_created', newId());
  });

  // Shopify Forms uses an open shadow root. Its app-embed step switches to
  // "success" only after submitForm succeeds. Observe that transition, never
  // generic submit/click events. This adapter depends on the app's current DOM.
  const observed = new WeakSet();
  function observeShopifyForms() {
    for (const host of document.querySelectorAll('shopify-forms-embed')) {
      if (!host.shadowRoot || observed.has(host)) continue;
      observed.add(host);
      let previous;
      const changed = () => {
        const step = host.shadowRoot.querySelector('#app-embed')?.getAttribute('data-current-step');
        if (step === 'success' && previous === 'form' && allowed()) publish('lead_created', newId());
        if (step) previous = step;
      };
      changed();
      new MutationObserver(changed).observe(host.shadowRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-current-step'] });
    }
  }
  function start() {
    confirmedThemeForms();
    observeShopifyForms();
    new MutationObserver(observeShopifyForms).observe(document.documentElement, { subtree: true, childList: true });
  }
  document.addEventListener('consenso:aggiornato', () => {
    if (document.readyState !== 'loading') confirmedThemeForms();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  // No success event is replayed when marketing consent is granted later.
})();
